import global from "./global";
import editor from "./editor";

export default {methods: {...global, ...editor}};